import { kebabCase } from 'lodash-es';

export default kebabCase;
